import axios from 'axios';
import { Notify } from 'quasar'

export function information_qualityManagement(userName, password)
{
    return new Promise((resolve) =>
    {
        axios(
        {
            method: 'get',
            url: 'https://zwszwqztccs.top/serverQualityManagement/information',

            params:
            {
                userName: userName,
                password: password,
            },
        })
        .then((response) =>
        {
            if (response.status === 200)
            {
                resolve(response.data)
            }
            else
            {
                Notify.create({ message: '服务器返回失败！', position: 'top', icon: "report_problem", color: "negative", timeout: 2000 });
            }
        })
        .catch(() =>
        {
            Notify.create({ message: '连接失败！', position: 'top', icon: "report_problem", color: "negative", timeout: 2000 });
        })
    });
}
